import { AgreementsSignaturesService, AgreementsDocumentsService } from '.'
import { ApiService } from '~/shared/api'
import { RequestService } from '~/services/RequestService'

class AgreementsService extends ApiService {
  protected route: string = 'agreements'
  public signatures: AgreementsSignaturesService
  public documents: AgreementsDocumentsService

  constructor(requestService: RequestService) {
    super(requestService)
    this.signatures = new AgreementsSignaturesService(requestService)
    this.documents = new AgreementsDocumentsService(requestService)
  }
}

export default AgreementsService
